import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  selectBookingExistsModalOpened,
  selectCallbackWidgetOpened,
} from 'shared/selectors/newbuildingBrokerCallbackWidget';

import { NewbuildingBrokerBookingExistsModalAdapterLoadable } from './NewbuildingBrokerBookingExistsModalAdapter';
import { NewbuildingBrokerCallbackWidgetAdapterLoadable } from './NewbuildingBrokerCallbackWidgetAdapter';

export const NewbuildingBrokerCallbackWidgetContainer = () => {
  const isCallbackWidgetOpened = useSelector(selectCallbackWidgetOpened);
  const isBookingExistsModalOpened = useSelector(selectBookingExistsModalOpened);

  return (
    <>
      {isCallbackWidgetOpened && <NewbuildingBrokerCallbackWidgetAdapterLoadable />}
      {isBookingExistsModalOpened && <NewbuildingBrokerBookingExistsModalAdapterLoadable />}
    </>
  );
};
